// MoneyWorks Header and Footer JavaScript

console.log("MW_NAV_JS_LOADED");

export default function initMoneyWorksHeaderFooter() {
  /* MW NAV CONTROLLER START */
  // Header functionality
  const navbar = document.getElementById('navbar');
  const hamburgerBtn = document.querySelector('[data-nav-toggle]');
  const mobileMenu = document.querySelector('[data-nav-menu]');
  const scrollDiv = navbar;
  
  // Verify required elements exist
  if (!hamburgerBtn) {
    console.error('MW_NAV_ERROR: [data-nav-toggle] not found');
  }
  if (!mobileMenu) {
    console.error('MW_NAV_ERROR: [data-nav-menu] not found');
  }

  // Update navbar class based on URL
  function updateNavbarClass() {
    const url = window.location.pathname;
    const buttonSection = document.querySelector('.white-navbar-button-section, .green-navbar-button-section');
    
    if (url.includes('/about')) {
      navbar.classList.add('green-navbar');
      navbar.classList.remove('white-navbar');
      if (buttonSection) {
        buttonSection.classList.remove('white-navbar-button-section');
        buttonSection.classList.add('green-navbar-button-section');
      }
      const logoDark = navbar.querySelector('.logo-dark');
      const logoWhite = navbar.querySelector('.logo-white');
      if (logoDark) logoDark.style.display = 'none';
      if (logoWhite) logoWhite.style.display = 'block';
    } else {
      navbar.classList.add('white-navbar');
      navbar.classList.remove('green-navbar');
      if (buttonSection) {
        buttonSection.classList.remove('green-navbar-button-section');
        buttonSection.classList.add('white-navbar-button-section');
      }
      const logoDark = navbar.querySelector('.logo-dark');
      const logoWhite = navbar.querySelector('.logo-white');
      if (logoDark) logoDark.style.display = 'block';
      if (logoWhite) logoWhite.style.display = 'none';
    }
  }

  // Scroll handler
  function handleScroll() {
    if (window.scrollY > 24) {
      scrollDiv.classList.add('scrolling');
    } else {
      scrollDiv.classList.remove('scrolling');
    }
  }

  // Mobile menu toggle - reliable controller
  let isMenuOpen = false;
  
  function toggleMobileMenu() {
    if (!hamburgerBtn || !mobileMenu) {
      console.error('MW_NAV_ERROR: Cannot toggle menu - elements missing');
      return;
    }
    
    isMenuOpen = !isMenuOpen;
    const lines = hamburgerBtn.querySelectorAll('.blue-line');
    
    if (isMenuOpen) {
      // Open menu
      mobileMenu.classList.add('is-open', 'show-layout');
      mobileMenu.classList.remove('hide-layout');
      lines[0]?.classList.add('blue-line-a');
      lines[1]?.classList.add('blue-line-b');
      lines[2]?.classList.add('blue-line-c');
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mw-nav-open');
      document.body.style.overflow = 'hidden';
    } else {
      // Close menu
      mobileMenu.classList.add('hide-layout');
      mobileMenu.classList.remove('is-open', 'show-layout');
      lines[0]?.classList.remove('blue-line-a');
      lines[1]?.classList.remove('blue-line-b');
      lines[2]?.classList.remove('blue-line-c');
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mw-nav-open');
      document.body.style.overflow = '';
      
      // Clean up after animation
      setTimeout(() => {
        if (!isMenuOpen) {
          mobileMenu.classList.remove('show-layout', 'hide-layout');
        }
      }, 350);
    }
  }
  
  function closeMobileMenu() {
    if (isMenuOpen) {
      toggleMobileMenu();
    }
  }
  
  // Initialize mobile menu controller
  if (hamburgerBtn && mobileMenu) {
    // Ensure initial state
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    if (mobileMenu.id) {
      hamburgerBtn.setAttribute('aria-controls', mobileMenu.id);
    }
    
    // Hamburger click handler
    hamburgerBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileMenu();
    });
    
    // ESC key handler
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeMobileMenu();
        hamburgerBtn.focus();
      }
    });

    // Close mobile menu when clicking on a link
    const mobileLinks = mobileMenu.querySelectorAll('.nav-link[href]');
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        closeMobileMenu();
      });
    });
    
    // Close button (cross) handler
    const closeBtn = mobileMenu.querySelector('[data-nav-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeMobileMenu();
      });
    }
    
    // Close mobile menu when clicking outside
    document.addEventListener('click', (e) => {
      if (isMenuOpen && 
          !mobileMenu.contains(e.target) && 
          !hamburgerBtn.contains(e.target)) {
        closeMobileMenu();
      }
    });
  }
  
  // Mobile dropdown close function
  function closeMobileDropdowns() {
    document.querySelectorAll('[data-dropdown-menu]').forEach(menu => {
      menu.classList.remove('is-open', 'show');
      const toggle = menu.closest('.dropdown-wrapper')?.querySelector('[data-dropdown-toggle]');
      const icon = menu.closest('.dropdown-wrapper')?.querySelector('.dropdownIcon');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (icon) icon.classList.remove('rotated');
    });
  }

  // Desktop dropdown functionality - matching Angular toggleDropdown()
  // Only select desktop dropdown toggles (not inside mobile menu)
  const allDropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');
  const dropdownToggles = Array.from(allDropdownToggles).filter(toggle => {
    // Exclude toggles inside mobile menu (mobileMenu is already declared above)
    return !mobileMenu || !mobileMenu.contains(toggle);
  });
  console.log('MW_NAV_DEBUG: Found', dropdownToggles.length, 'desktop dropdown toggles (out of', allDropdownToggles.length, 'total)');
  let openDropdown = null;
  
  function closeDropdown() {
    if (openDropdown) {
      const hasDropdown = openDropdown.closest('.has-dropdown');
      if (hasDropdown) {
        hasDropdown.classList.remove('is-open');
      }
      openDropdown.classList.remove('show');
      const toggle = hasDropdown?.querySelector('[data-dropdown-toggle]');
      if (toggle) {
        toggle.classList.remove('dropdown-open');
        toggle.setAttribute('aria-expanded', 'false');
        const icon = toggle.querySelector('.dropdown-icon-svg');
        if (icon) icon.classList.remove('rotated');
      }
      openDropdown = null;
    }
  }
  
  function toggleDropdown(menuName, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    const toggle = document.querySelector(`[data-dropdown="${menuName}"]`);
    if (!toggle) return;
    
    const dropdownMenu = toggle.closest('.dropdown-item')?.querySelector('[data-dropdown-menu]');
    if (!dropdownMenu) return;
    
    if (openDropdown === dropdownMenu) {
      closeDropdown();
    } else {
      // Close other dropdowns first
      closeDropdown();
      
      // Open this dropdown
      dropdownMenu.classList.add('show');
      toggle.classList.add('dropdown-open');
      toggle.setAttribute('aria-expanded', 'true');
      const icon = toggle.querySelector('.dropdown-icon-svg');
      if (icon) icon.classList.add('rotated');
      openDropdown = dropdownMenu;
    }
  }
  
  /* MW NAV/DROPDOWN FIX START */
  // Desktop: click-only behavior (no hover)
  // Use event delegation on navbar for better reliability
  const navbarNav = document.querySelector('.navbar-nav');
  
  if (navbarNav) {
    // Handle clicks on dropdown toggles using event delegation
    navbarNav.addEventListener('click', (e) => {
      // Only handle on desktop (>= 992px)
      if (window.innerWidth < 992) return;
      
      // Find the closest dropdown toggle
      const toggle = e.target.closest('[data-dropdown-toggle]');
      if (!toggle) return;
      
      // Make sure it's not in mobile menu
      if (mobileMenu && mobileMenu.contains(toggle)) return;
      
      const menuName = toggle.getAttribute('data-dropdown');
      const hasDropdown = toggle.closest('.has-dropdown');
      const dropdownMenu = hasDropdown?.querySelector('[data-dropdown-menu]');
      
      if (!dropdownMenu || !hasDropdown) {
        console.warn('MW_NAV_WARNING: Dropdown elements not found for', menuName);
        return;
      }
      
      console.log('MW_NAV_DEBUG: Click detected on dropdown toggle', menuName);
      
      e.preventDefault();
      e.stopPropagation();
      
      if (hasDropdown.classList.contains('is-open')) {
        // Close if already open
        console.log('MW_NAV_DEBUG: Closing dropdown', menuName);
        hasDropdown.classList.remove('is-open');
        toggle.classList.remove('dropdown-open');
        toggle.setAttribute('aria-expanded', 'false');
        dropdownMenu.classList.remove('show');
        const icon = toggle.querySelector('.dropdown-icon-svg');
        if (icon) icon.classList.remove('rotated');
        openDropdown = null;
      } else {
        // Close other dropdowns first
        closeDropdown();
        // Open this dropdown
        console.log('MW_NAV_DEBUG: Opening dropdown', menuName);
        hasDropdown.classList.add('is-open');
        toggle.classList.add('dropdown-open');
        toggle.setAttribute('aria-expanded', 'true');
        dropdownMenu.classList.add('show');
        const icon = toggle.querySelector('.dropdown-icon-svg');
        if (icon) icon.classList.add('rotated');
        openDropdown = dropdownMenu;
      }
    });
  }
  
  // Also attach directly to toggles as backup
  dropdownToggles.forEach((toggle, index) => {
    const menuName = toggle.getAttribute('data-dropdown');
    const hasDropdown = toggle.closest('.has-dropdown');
    const dropdownMenu = hasDropdown?.querySelector('[data-dropdown-menu]');
    
    console.log(`MW_NAV_DEBUG: Attaching handler to dropdown ${index}:`, menuName);
    
    if (!dropdownMenu || !hasDropdown) {
      console.warn('MW_NAV_WARNING: Dropdown elements not found for', menuName);
      return;
    }
    
    // Prevent dropdown from closing when clicking inside
    dropdownMenu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
  /* MW NAV/DROPDOWN FIX END */

  // Close dropdowns when clicking outside - matching Angular handleClickOutside()
  document.addEventListener('click', (e) => {
    // Desktop dropdowns
    if (window.innerWidth >= 992) {
      const isInsideDesktopDropdown = e.target.closest('.has-dropdown') || e.target.closest('[data-dropdown-menu]');
      if (!isInsideDesktopDropdown && openDropdown) {
        closeDropdown();
      }
    }
    
    // Mobile dropdowns - close if clicking outside
    if (window.innerWidth < 992) {
      const isInsideMobileDropdown = e.target.closest('.dropdown-wrapper') || 
                                     e.target.closest('[data-dropdown-menu]') ||
                                     e.target.closest('[data-dropdown-toggle]');
      if (!isInsideMobileDropdown) {
        closeMobileDropdowns();
      }
    }
  });
  
  // Close desktop dropdowns on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (window.innerWidth >= 992 && openDropdown) {
        closeDropdown();
        const toggle = openDropdown.closest('.dropdown-item')?.querySelector('[data-dropdown-toggle]');
        if (toggle) toggle.focus();
      } else if (window.innerWidth < 992) {
        // Close mobile dropdowns on ESC
        closeMobileDropdowns();
      }
    }
  });
  
  /* MW NAV CONTROLLER END */

  // Mobile dropdown functionality - using data attributes
  function toggleMobileDropdown(dropdownName) {
    if (window.innerWidth >= 992) {
      console.log('MW_NAV_DEBUG: toggleMobileDropdown called on desktop, ignoring');
      return; // Only on mobile
    }
    
    console.log('MW_NAV_DEBUG: toggleMobileDropdown called for', dropdownName);
    
    // Find toggle and menu - must be inside mobile menu
    const mobileMenuContainer = document.querySelector('[data-nav-menu]');
    if (!mobileMenuContainer) {
      console.error('MW_NAV_ERROR: Mobile menu container not found');
      return;
    }
    
    const toggle = mobileMenuContainer.querySelector(`[data-dropdown-toggle="${dropdownName}"]`);
    const menu = mobileMenuContainer.querySelector(`[data-dropdown-menu="${dropdownName}"]`);
    const icon = toggle?.closest('.subMenu')?.querySelector('.dropdownIcon');
    
    console.log('MW_NAV_DEBUG: Mobile dropdown elements:', { toggle, menu, icon });
    
    if (!toggle || !menu) {
      console.error(`MW_NAV_ERROR: Dropdown "${dropdownName}" not found in mobile menu`);
      return;
    }
    
    const isOpen = menu.classList.contains('is-open') || menu.classList.contains('show');
    console.log('MW_NAV_DEBUG: Dropdown is currently', isOpen ? 'open' : 'closed');
    
    // Close all other mobile dropdowns first
    mobileMenuContainer.querySelectorAll('[data-dropdown-menu]').forEach(m => {
      if (m !== menu) {
        m.classList.remove('is-open', 'show');
        const otherToggle = m.closest('.dropdown-wrapper')?.querySelector('[data-dropdown-toggle]');
        const otherIcon = m.closest('.dropdown-wrapper')?.querySelector('.dropdownIcon');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        if (otherIcon) otherIcon.classList.remove('rotated');
      }
    });
    
    if (isOpen) {
      // Close this dropdown
      console.log('MW_NAV_DEBUG: Closing mobile dropdown', dropdownName);
      menu.classList.remove('is-open', 'show');
      toggle.setAttribute('aria-expanded', 'false');
      if (icon) icon.classList.remove('rotated');
    } else {
      // Open this dropdown
      console.log('MW_NAV_DEBUG: Opening mobile dropdown', dropdownName);
      menu.classList.add('is-open', 'show');
      toggle.setAttribute('aria-expanded', 'true');
      if (icon) icon.classList.add('rotated');
    }
  }
  
  // Initialize mobile dropdown handlers - using event delegation
  const mobileMenuContainer = document.querySelector('[data-nav-menu]');
  if (mobileMenuContainer) {
    console.log('MW_NAV_DEBUG: Mobile menu container found, setting up dropdown handlers');
    
    // Use event delegation on the mobile menu container
    mobileMenuContainer.addEventListener('click', (e) => {
      // Only handle on mobile
      if (window.innerWidth >= 992) return;
      
      // Check if click is on a dropdown toggle or icon
      const toggle = e.target.closest('[data-dropdown-toggle]');
      if (!toggle) return;
      
      // Make sure it's inside the mobile menu
      if (!mobileMenuContainer.contains(toggle)) return;
      
      const dropdownName = toggle.getAttribute('data-dropdown-toggle');
      if (!dropdownName) return;
      
      console.log('MW_NAV_DEBUG: Mobile dropdown toggle clicked:', dropdownName);
      
      e.preventDefault();
      e.stopPropagation();
      toggleMobileDropdown(dropdownName);
    });
    
    // Log how many mobile dropdowns were found
    const mobileDropdownToggles = mobileMenuContainer.querySelectorAll('[data-dropdown-toggle]');
    console.log('MW_NAV_DEBUG: Found', mobileDropdownToggles.length, 'mobile dropdown toggles');
  } else {
    console.warn('MW_NAV_WARNING: Mobile menu container not found');
  }

  // Footer dropdown functionality - matching Angular toggleDropdown(index)
  const footerToggleButtons = document.querySelectorAll('.btn-toggle[data-toggle]');
  const footerDropdowns = {
    1: 'about',
    2: 'connect',
    3: 'legal',
    4: 'solutions'
  };
  
  function toggleFooterDropdown(index) {
    const dropdownName = footerDropdowns[index];
    if (!dropdownName) return;
    
    const button = document.querySelector(`.btn-toggle[data-toggle="${dropdownName}"]`);
    const dropdown = document.getElementById(dropdownName + 'Dropdown');
    
    if (!button || !dropdown) return;
    
    const isOpen = dropdown.classList.contains('show') || button.classList.contains('active');
    
    // Close all dropdowns first
    document.querySelectorAll('#aboutDropdown, #solutionsDropdown, #connectDropdown, #legalDropdown').forEach(d => {
      d.classList.remove('show');
    });
    document.querySelectorAll('.btn-toggle[data-toggle]').forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-expanded', 'false');
    });
    
    // If the clicked dropdown was closed, open it. If it was open, it stays closed (toggle behavior)
    if (!isOpen) {
      dropdown.classList.add('show');
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  }
  
  footerToggleButtons.forEach(button => {
    const toggleName = button.getAttribute('data-toggle');
    const index = Object.keys(footerDropdowns).find(key => footerDropdowns[key] === toggleName);
    
    if (index) {
      button.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent event bubbling
        toggleFooterDropdown(parseInt(index));
      });
    }
  });

  // Open Solutions dropdown by default on mobile
  if (window.innerWidth <= 767) {
    const solutionsDropdown = document.getElementById('solutionsDropdown');
    const solutionsButton = document.querySelector('.btn-toggle[data-toggle="solutions"]');
    if (solutionsDropdown && solutionsButton) {
      solutionsDropdown.classList.add('show');
      solutionsButton.classList.add('active');
      solutionsButton.setAttribute('aria-expanded', 'true');
    }
  }

  // Footer dropdowns are closed by the global click handler above

  // Initialize
  updateNavbarClass();
  handleScroll();
  window.addEventListener('scroll', handleScroll);

  // Update navbar on navigation (for SPA-like behavior if needed)
  const observer = new MutationObserver(() => {
    updateNavbarClass();
  });

  if (navbar) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}
